module.exports = __webpack_public_path__ + "static/media/img_9.9701116d.png";